// Component names
export const GLOBAL_SEARCH_COMPONENT = 'nav-components:global-search' as const;
export const DUMMY_COMPONENT = 'nav-components:dummy' as const;
export const CHATSPOT_SIDEBAR_COMPONENT =
  'nav-components:chatspot-sidebar' as const;
export const IN_APP_HELP_COMPONENT = 'nav-components:in-app-help' as const;
export const GROWTH_PROMPTS_COMPONENT =
  'nav-components:growth-prompts' as const;
export const NOTIFICATIONS_BANNER_COMPONENT =
  'nav-components:notifications-banner' as const;
export const NOTIFICATIONS_FLOATING_COMPONENT =
  'nav-components:notifications-floating' as const;
export const NOTIFICATIONS_TEASE_COMPONENT =
  'nav-components:notifications-tease' as const;
export const NOTIFICATIONS_SIDEBAR_COMPONENT =
  'nav-components:notifications-sidebar' as const;
export const CALLING_COMPONENT = 'nav-components:calling' as const;
export const OBJECT_BUILDER_NAV_COMPONENT =
  'nav-components:object-builder-nav' as const;
export const NAV_OBJECT_CREATE_COMPONENT =
  'nav-components:nav-object-create' as const;
export const MARKETPLACE_MODAL_COMPONENT =
  'nav-components:marketplace-modal' as const;
export const BREEZE_IMAGE_MODAL_COMPONENT =
  'nav-components:breeze-image-modal' as const;
export const MARKETPLACE_NAV_MENU_COMPONENT =
  'nav-components:marketplace-nav-menu' as const;
export const CREDIT_BALANCE_POPOVER_COMPONENT =
  'nav-components:credit-balance-popover' as const;
export const ACADEMY_TOOLBAR_COMPONENT =
  'nav-components:academy-toolbar' as const;
export const ACADEMY_PRACTICE_MODE_TOOLBAR_COMPONENT =
  'nav-components:academy-practice-mode-toolbar' as const;
export const ACADEMY_EXERCISE_INSTRUCTIONS_COMPONENT =
  'nav-components:academy-exercise-instructions' as const;
export const ACADEMY_PRACTICE_MODE_STARTER_COMPONENT =
  'nav-components:academy-practice-mode-starter' as const;
export const NAV_ONBOARDING_TOURS_COMPONENT =
  'nav-components:nav-onboarding-tours' as const;
export const USER_INVITE_MODAL_COMPONENT =
  'nav-components:user-invite-modal' as const;
export const GROWTH_IN_APP_SIDEPANEL_COMPONENT =
  'nav-components:growth-in-app-sidepanel' as const;
export const MINI_TRIAL_GUIDE_COMPONENT =
  'nav-components:mini-trial-guide' as const;
export const GROW_GUIDE_COMPONENT = 'nav-components:grow-guide' as const;
export const GROWTH_ONBOARDING_NEXT_ACTION_MODAL_COMPONENT =
  'nav-components:growth-onboarding-next-action-modal' as const;
export const GROWTH_ONBOARDING_COMPANION_COMPONENT =
  'nav-components:growth-onboarding-companion' as const;
export const ACADEMY_RECOMMENDATIONS_MODAL_COMPONENT =
  'nav-components:academy-recommendations-modal' as const;
export const BREEZE_EMAIL_SUPPORT_MODAL_COMPONENT =
  'nav-components:breeze-email-support-modal' as const;
export const BREEZE_MANAGE_SKILLS_MODAL_COMPONENT =
  'nav-components:breeze-manage-skills-modal' as const;
export const GROWTH_REQUEST_SEAT_MODAL_COMPONENT =
  'nav-components:growth-request-seat-modal' as const;
export const BOOKMARKS_MANAGER_COMPONENT =
  'nav-components:bookmarks-manager' as const;
export const PAPERCUTS_FEEDBACK_COMPONENT =
  'nav-components:papercuts-feedback' as const;
export const BREEZE_PROJECTS_UI_MODAL_COMPONENT =
  'nav-components:breeze-projects-ui-modal' as const;
export const BREEZE_SHARING_UI_MODAL_COMPONENT =
  'nav-components:breeze-sharing-ui-modal' as const;
export const CONNECTION_SETTINGS_MODAL_COMPONENT =
  'nav-components:connection-settings-modal' as const;
export const GROUPS_MANAGER_COMPONENT =
  'nav-components:groups-manager' as const;
export const TALK_TO_SALES_MODAL_COMPONENT =
  'nav-components:talk-to-sales-modal' as const;
export const TRIAL_START_MODAL_COMPONENT =
  'nav-components:trial-start-modal' as const;
export const SANDBOX_TOOLING_COMPONENT =
  'nav-components:sandbox-tooling' as const;

// Component tags
export const Tags = {
  SIDE_PANEL: 'SIDE_PANEL',
  MODAL: 'MODAL',
  BANNER: 'BANNER',
} as const;

export type Tags = typeof Tags;
export type Tag = Tags[keyof Tags];
export type TagList = ReadonlyArray<Tag>;

// Loggers
export const PLATFORM_LOGGER = 'NAVIGATION_COMPONENTS_PLATFORM_LOGGER' as const;
export const SCHEDULER_LOGGER =
  'NAVIGATION_COMPONENTS_SCHEDULER_LOGGER' as const;

// Others
export const DEFAULT_PLATFORM_NAME = 'unified-navigation-ui';
export const NC_PLATFORM_NAME = 'unified-navigation-ui';
